import React from "react";
import { number, string, object } from "prop-types";
import { formatDistance } from "date-fns";
import { bn } from "date-fns/locale";
import { connect } from "react-redux";
import get from "lodash/get";

import { getEngStoryPageDate } from "../../utils/utils";

import "./publishedAt.m.css";

const PublishedAt = ({ date, className = "published-at", publisherAttributes }) => {
  if (!date) {
    return null;
  }

  const banglaDate = formatDistance(new Date(date), new Date(), {
    locale: bn,
    addSuffix: true,
  });

  return (
    <time
      styleName={`published-at ${publisherAttributes.lang === "en" ? "en-published-at" : ""}`}
      className={`${className} ${publisherAttributes.lang === "en" ? "en-published-at" : ""}`}
    >
      {publisherAttributes.lang === "bn" ? banglaDate : getEngStoryPageDate(date)}
    </time>
  );
};

PublishedAt.propTypes = {
  date: number,
  className: string,
  publisherAttributes: object,
};

const mapStateToProps = (state) => ({
  publisherAttributes: get(state, ["qt", "config", "publisher-attributes"], {}),
});

export default connect(mapStateToProps, null)(PublishedAt);
